import BinaryDataHeaderSerializer from './binaryData/HeaderSerializer';
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_13';

const v0_0_13: SerializerRegistry = {
    version,
    binary: {
        HeaderSerializer: new (BinaryDataHeaderSerializer as any)(version),
    },
};

export default v0_0_13;
